import React__default from 'react';

const RecaptchaContext = /*#__PURE__*/ React__default.createContext({});
const RecaptchaProvider = ({ children , settings  })=>{
    const context = {
        settings
    };
    return /*#__PURE__*/ React__default.createElement(RecaptchaContext.Provider, {
        value: context
    }, children);
};

export { RecaptchaContext, RecaptchaProvider };
//# sourceMappingURL=RecaptchaProvider.js.map
